import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import { DrawerProps as Props } from './types';
import Loader from '../Loader';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';

import variables from '@wix/da-ds/src/styles/variables.scss';
const siteHeaderHeight = parseInt(variables['site-header-height'], 10);

const Drawer = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "notifications_shared" */
        './index'
      )
  )
);

export const DrawerLoadable: React.FC<Props> = props => {
  return (
    <ErrorBoundary debugComponent="DrawerLoadable">
      <AbsoluteHeightLayout
        heightReduction={siteHeaderHeight}
        disableIfDvSupported
      >
        <Suspense fallback={<Loader type="drawer-suspense" />}>
          <ModuleLoaderLazy />
          <Drawer {...props} />
        </Suspense>
      </AbsoluteHeightLayout>
    </ErrorBoundary>
  );
};
DrawerLoadable.displayName = 'DrawerLoadable';

export default DrawerLoadable;
